module.exports = __webpack_public_path__ + "img/bg3.0e18f142.jpg";